import { useState } from "react";
import { Button } from "V2.0/common/button";
import { useVoiceSettings } from "../useVoiceSettings";
import { Switch } from "V2.0/common/switch";
import InputComponent from "V2.0/components/InputComponent";

function VoicemailDetectionSwitch(props) {
  const { isVoicemailDetectionEnabled, onToggleVoicemailDetection, disabled } =
    props;

  return (
    <Switch
      color="emerald"
      checked={isVoicemailDetectionEnabled}
      onClick={onToggleVoicemailDetection}
      disabled={disabled}
    />
  );
}

function VoicemailDetectionSettings(props) {
  const { voicemailDetectionSettings, onUpdate, locked } = props;

  function handleToggleVoicemailDetection() {
    onUpdate({
      voicemailDetectionEnabled:
        !voicemailDetectionSettings.voicemailDetectionEnabled,
    });
  }

  function handleUpdateVoicemailMessage(message) {
    onUpdate({
      voicemailMessage: message,
    });
  }

  return (
    <div className="grid grid-cols-4 px-8 space-y-4">
      <div className="col-span-4 flex flex-col gap-y-1">
        <div className="flex items-center gap-x-4">
          <p className="text-sm font-medium">Leave Voicemail Message</p>
          <VoicemailDetectionSwitch
            isVoicemailDetectionEnabled={
              voicemailDetectionSettings.voicemailDetectionEnabled
            }
            onToggleVoicemailDetection={handleToggleVoicemailDetection}
            disabled={locked}
          />
        </div>
        <p className="text-sm mt-1 text-gray-500">
          Speaks the message if the call goes to voicemail.
        </p>
      </div>
      <div className="col-span-4 ml-4">
        <InputComponent
          disabled={
            !voicemailDetectionSettings.voicemailDetectionEnabled || locked
          }
          type="textArea"
          style={{ height: "100px", fontSize: "13px" }}
          label="Message"
          value={voicemailDetectionSettings.voicemailMessage}
          onChange={(e) => handleUpdateVoicemailMessage(e.target.value)}
        />
      </div>
    </div>
  );
}

function CallOnHoldDetectionSwitch(props) {
  const {
    isCallOnHoldDetectionEnabled,
    onToggleCallOnHoldDetection,
    disabled,
  } = props;

  return (
    <Switch
      color="emerald"
      checked={isCallOnHoldDetectionEnabled}
      onClick={onToggleCallOnHoldDetection}
      disabled={disabled}
    />
  );
}

function CallOnHoldDetectionSettings(props) {
  const {
    callOnHoldDetectionEnabled,
    syncAssistant,
    workspaceId,
    assistantId,
    locked,
  } = props;

  const { updateVoiceSettings } = useVoiceSettings({
    syncAssistant,
    workspaceId,
    assistantId,
  });

  const [settings, setSettings] = useState({
    callOnHoldDetectionEnabled,
  });

  function handleToggleCallOnHoldDetection() {
    const updatedSetting = {
      callOnHoldDetectionEnabled: !callOnHoldDetectionEnabled,
    };

    setSettings(updatedSetting);

    const lifecycleCbs = {
      onError: (e) => {
        setSettings({ callOnHoldDetectionEnabled: callOnHoldDetectionEnabled });
      },
    };

    updateVoiceSettings(updatedSetting, lifecycleCbs);
  }

  return (
    <div className="flex justify-between w-full border rounded-lg p-4 px-6 bg-gray-50">
      <div className="">
        <p className="font-semibold text-md">Auto Call-End on Hold</p>
        <p className="text-sm mt-1 text-gray-500">
          Ends the call automatically if put on hold
        </p>
      </div>
      <div>
        <CallOnHoldDetectionSwitch
          isCallOnHoldDetectionEnabled={settings.callOnHoldDetectionEnabled}
          onToggleCallOnHoldDetection={handleToggleCallOnHoldDetection}
          disabled={locked}
        />
      </div>
    </div>
  );
}

function VoicemailSettings(props) {
  const {
    voicemailDetectionSettings,
    syncAssistant,
    workspaceId,
    assistantId,
    locked,
  } = props;

  const { updateVoiceSettings } = useVoiceSettings({
    syncAssistant,
    workspaceId,
    assistantId,
  });

  const [settings, setSettings] = useState({
    voicemailDetectionSettings,
  });

  const [loading, setLoading] = useState(false);

  function handleUpdateVoicemailSettings(modifiedSetting) {
    setSettings((prevSettings) => {
      return {
        ...prevSettings,
        voicemailDetectionSettings: {
          ...prevSettings.voicemailDetectionSettings,
          ...modifiedSetting,
        },
      };
    });
  }

  function handleSave() {
    updateVoiceSettings(settings);
  }

  return (
    <div className="flex flex-col w-full gap-y-8 border rounded-lg">
      <div className="px-6 py-4 bg-gray-50 rounded-t-lg">
        <p className="text-md font-semibold text-gray-900">Voicemail</p>
        {/* <p className="text-sm mt-1 text-gray-500">
          Configure whether a voicemail message is played and what it says.
        </p> */}
      </div>

      <div className="grid space-y-8">
        <VoicemailDetectionSettings
          voicemailDetectionSettings={settings.voicemailDetectionSettings}
          onUpdate={handleUpdateVoicemailSettings}
          locked={locked}
        />
      </div>

      <div className="bg-gray-50 rounded-b-lg px-4 py-3 text-right">
        {!locked && (
          <Button
            loading={loading}
            onClick={handleSave}
          >
            Save
          </Button>
        )}
      </div>
    </div>
  );
}

export default function VoicemailAndCallOnHoldSettings(props) {
  return (
    <div className="flex flex-col gap-y-8 m-4 w-3/5 min-w-[600px]">
      <CallOnHoldDetectionSettings {...props} />
      <VoicemailSettings {...props} />
    </div>
  );
}
